var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operate"},[_c('Button',{staticClass:"btn cancel",attrs:{"size":"large"}},[_vm._v(" 返回修改 ")]),_vm._v("      "),_c('Button',{staticClass:"btn submit",attrs:{"size":"large","html-type":"submit","type":"primary"}},[_vm._v(" 立即投保 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }